import { Row, Card, Col, Form, Stack, Tabs, Tab } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { store } from "Store";
import { useDispatch } from "react-redux";
import InfoTable from "Components/InfoTable/InfoTable";
import { getBatchDetail } from "./ViewBatchAxiosFuncs";
import { ERROR_MESSAGES } from "Utils/constants";
import { setGlobalErrorStatus } from "Components/StatusHandling";
import { TextButton } from "Components/Button";
import NewPSOTable from "./NewPSOTable";
import DelistedPSOTable from "./DelistedPSOTable";

const ViewBatch = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loginState = store.getState().loginInfo;
  
  const location = useLocation();
  const passed = location.state || {};
  const { batchId, backRedirect } = passed || {};
  
  const [isLoading, setIsLoading] = useState(true);
  const [batchData, setBatchData] = useState(null);
  
  const fmtDate = (time) => {
    if (time == null) return "";
    const d = new Date(time);
    const pad2 = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())} ` +
      `${pad2(d.getHours())}:${pad2(d.getMinutes())}:${pad2(d.getSeconds())}.0`;
  };
  
  const lastModifiedFmtDate = (time) => {
    if (time == null) return "";
    const d = new Date(time);
    const pad2 = (n) => String(n).padStart(2, "0");
    return `${pad2(d.getMonth() + 1)}/${pad2(d.getDate())}/${d.getFullYear()} ` +
      `${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
  };
  
  useEffect(() => {
    setIsLoading(true);
    getBatchDetail("Bearer " + loginState.token, batchId)
      .then((res) => {
        setBatchData(res.data.data);
      })
      .catch((error) => {
        const payload = error?.data ?? error;
        setGlobalErrorStatus({
          dispatch,
          popupData: {
            visible: true,
            title: ERROR_MESSAGES.DATA_ERROR.title,
            msg:
              payload?.data?.globalErrorMessageList?.[0] ??
              ERROR_MESSAGES.DATA_ERROR.message,
            showContactHelp: true
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          },
          error
        });
      })
      .finally(() => setIsLoading(false));
  }, [batchId]);
  
  const colSizes = {
    label: { xl: 3, lg: 4, md: 4, sm: 4, xs: 5 },
    value: { xl: 9, lg: 8, md: 8, sm: 8, xs: 7 }
  };
  
  const infoTableData = () => {
    if (!batchData) return [];
    return [
      { name: "Batch ID", value: batchData.batchId },
      { name: "Batch File Name", value: batchData.fileName },
      { name: "Batch Date", value: fmtDate(batchData.batchDate) },
      { name: "Batch Processed Date", value: fmtDate(batchData.processDate) },
      { name: "Batch Status", value: batchData.batchStatus?.statusName },
      { name: "Last Modified", value: lastModifiedFmtDate(batchData.releaseDate) },
      { name: "No. of Entries", value: batchData.numOfEntry },
      { name: "No. of New PSOs", value: batchData.numberOfNewPSO },
      { name: "No. of Delisted PSOs", value: batchData.numberOfDelistedPSO }
    ];
  };
  
  const handleBack = () => {
    if (!backRedirect?.path) {
      navigate("/psoppc_web/manage/directory");
      return;
    }
    navigate(backRedirect.path, { state: backRedirect.state });
  };
  
  return (
    <Row>
      {isLoading || !batchData ? null : (
        <Col xl={11} lg={11} md={11} sm={12}>
          <Card className="p-4">
            <Card.Body className="text-start">
              <Row>
                <h1 id="mainContent" className="header1 text-start mb-3 blue bold">
                  PSO Directory Update Batch Detail
                </h1>
              </Row>
              <Row>
                <Form>
                  <Col md={12} lg={12} xl={12}>
                    <h2>Batch Information</h2>
                    <InfoTable data={infoTableData()} colSizes={colSizes} />
                  </Col>
                </Form>
              </Row>
              <Row className="mt-4">
                <Form>
                  <Col>
                    <h2>New &amp; Delisted PSO List</h2>
                    <Tabs
                      id="batchSubTabs"
                      defaultActiveKey="new"
                    >
                      <Tab eventKey="new" title="New PSO">
                        <NewPSOTable batchId={batchData?.batchId} />
                      </Tab>
                      <Tab eventKey="delisted" title="Delisted PSO">
                        <DelistedPSOTable batchId={batchData?.batchId} />
                      </Tab>
                    </Tabs>
                  </Col>
                  <Stack className="mt-3" direction="horizontal" gap={3}>
                    <TextButton
                      variant="outline"
                      onClick={handleBack}
                      content={"Back"}
                      className="ms-auto"
                    />
                  </Stack>
                </Form>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      )}
    </Row>
  );
};

export default ViewBatch;
